import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ToolService } from '../../../camtl.service';
import { SystemSelectService } from '../../../system-select/system-select.service';
import { Tool } from '../../../../../shared/model';
import { RouteValidationService } from "../../../../../shared/route-validation.service";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'assign-tools-dialog',
  templateUrl: './assign-tools-dialog.component.html',
  //styleUrls: ['./assign-tools-dialog.component.scss']
})
export class AssignToolsDialogComponent implements OnInit, OnDestroy {

  system: any;
  @Input() rowId: number;
  @Input() showWindow: boolean;
  @Input() cellNumber: string;
  @Input() stationNumber: string;

  allItems: Tool[];
  selectedItems: Tool[] = [];

  @Output() save: EventEmitter<any> = new EventEmitter();
  @Output() cancel: EventEmitter<any> = new EventEmitter();

  constructor(private service: ToolService,
    public routeValidationService: RouteValidationService,

    private systemSelectService: SystemSelectService) { }
  private ngUnsubscribe: Subject<void> = new Subject<void>();


  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }


  ngOnInit() {
    var self = this;
    this.systemSelectService.system$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(system => {
        this.system = system;
        if (this.system && (this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/Detail/SystemLayout') || this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/Detail/Cells') || this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/Detail/Stations'))) {
          this.service.read("/unassigned/" + this.system.Id, true)
            .then(function (response) {
              if (response.length > 0 && response[0].ToolDetail.ToolNumber) {
                self.allItems = response;
                for (var i = 0; i < self.allItems.length; i++) {
                  self.allItems[i]["DisplayNumber"] = self.allItems[i].ToolDetail.ToolNumber;
                }
              }
            });
        }

      })
    this.systemSelectService.get();
  }

  ngOnChanges() {
    var self = this;
    if (this.system && (this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/Detail/SystemLayout') || this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/Detail/Cells') || this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/Detail/Stations'))) {
      this.service.read("/unassigned/" + this.system.Id, true)
        .then(function (response) {
          if (response.length > 0 && response[0].ToolDetail.ToolNumber) {
            self.allItems = response;
            for (var i = 0; i < self.allItems.length; i++) {
              self.allItems[i]["DisplayNumber"] = self.allItems[i].ToolDetail.ToolNumber;
            }
          }

        });
    }
  }

  onValueChange(e) {
    this.selectedItems = [];
    for (var i = 0; i < this.allItems.length; i++) {
      if (e.indexOf(this.allItems[i].Id) !== -1) {
        this.selectedItems.push(this.allItems[i]);
      }
    }
  }

  onSave(e, value: any) {
    e.preventDefault();
    if (this.selectedItems) {
      for (var i = 0; i < this.selectedItems.length; i++) {
        this.selectedItems[i].ParentId = this.rowId;
        if (this.cellNumber && this.cellNumber !== null) {
          this.selectedItems[i].CellNumber = this.cellNumber;
        }
        if (this.stationNumber && this.stationNumber !== null) {
          this.selectedItems[i].StationNumber = this.stationNumber;
        }
      }
    }

    this.save.emit(this.selectedItems);
  }

  onCancel(e) {
    e.preventDefault();
    this.onClose();
  }

  onClose() {
    this.showWindow = false;
    this.cancel.emit();
  }
}
